/**
 * The footer's outgoing addresses.
 *
 * Kept apart from the component so they can be checked without a browser: a
 * malformed URL is invisible on screen — it looks like a perfectly ordinary
 * button right up to the moment someone presses it.
 */

/**
 * An address the organiser pasted in: the venue's map link, the legal pages.
 *
 * ⚠️ `javascript:` and `data:` URLs are REFUSED. These settings are written by
 * organisers, and in the real product a write currently requires no particular
 * right (see `store.ts`) — so treating them as trusted would turn a footer field
 * into a way to run code in every visitor's browser.
 *
 * An address with no scheme gets `https://`: organisers type "gayakoa.com", and
 * a bare relative link would quietly point inside the site instead.
 */
export function externalUrl(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const value = raw.trim();
  if (!value) return null;

  const candidate = /^[a-z][a-z0-9+.-]*:/i.test(value)
    ? value
    : `https://${value}`;
  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    return null;
  }
  return url.protocol === "http:" || url.protocol === "https:"
    ? url.href
    : null;
}
